import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import toast from "react-hot-toast";
import { read, utils } from 'xlsx';
import { RiLoader4Line, RiCheckLine, RiCloseLine } from "react-icons/ri";

import CustomTable from '../../../common/CustomTable';
import CustomUploadButton from '../../../common/CustomUploadButton/index'
import CustomRoundedInput from '../../../common/CustomInput/CustomRoundedInput';
import CustomInputV2 from '../../../common/CustomInputV2';
import CustomActionButton from '../../../common/CustomActionButton';

import { apiCallV2 } from "../../../utils/api";

const AddOrganization = ({ setAddOrgState }) => {

    const navigate = useNavigate()
    const [orgData, setOrgData] = useState({
        companyName: '',
        launchDate: '',
        companyId: '',
    })

    const [errors, setErrors] = useState({
        companyName: false,
        launchDate: false,
        companyId: false
    })
    const [orgFile, setOrgFile] = useState('')
    const [logoFile, setLogoFile] = useState('')
    const [employeeList, setEmployeeList] = useState([])
    const [search, setSearch] = useState("");
    const [page, setPage] = useState(1);
    const [count, setCount] = useState(0)
    const [perPage, setPerPage] = useState(10)


    const handleInputOnChange = (e) => {
        setOrgData(prev => ({ ...prev, [e.target.name]: e.target.value }))
    }

    const ExtensionChecker = (file) => {
        return file?.name.slice((Math.max(0, file?.name.lastIndexOf(".")) || Infinity) + 1);
    }
    // onchange event in submitting excel file of new organization
    const SetUploadedFile = async (e) => {
        let files = e.target.files;
        files = [...files]

        if (files.length > 0) {

            // check uploaded file if it is excel file
            let ExtensionCheck = ExtensionChecker(files[0])
            let allowedExtension = ["xlsx"]
            if (!allowedExtension.includes(ExtensionCheck)) {
                toast.error('Incorret File Type')
                return
            }
            setOrgFile(files[0])
            let reader = new FileReader();

            reader.onload = (e) => {
                let data = e.target.result;
                let workbook = read(data, {
                    type: 'binary'
                });


                workbook.SheetNames.forEach((sheetName, i) => {

                    // if (sheetName == "Sample") {
                    if (i === 0) {
                        let XL_row_object = utils.sheet_to_row_object_array(workbook.Sheets[sheetName]);

                        // rename file properties
                        let newXL_row_object = XL_row_object.map(item => {
                            const { Department: department, "Employee Email*": employee_email, "Employee First*": employee_first, "Employee Last*": employee_last, "Mobile Number": mobile_number, "Work Location ": work_location, "Employee ID": employee_id, ...rest } = item;
                            return { department, employee_email, employee_first, employee_last, mobile_number, work_location, employee_id, ...rest }
                        })

                        // take out the last row of the array, for unnecessary value
                        let slicedXL_row_object = newXL_row_object.slice(0, newXL_row_object.length)
                        setEmployeeList(slicedXL_row_object)
                    }

                    if (sheetName === "indi-video-tracking") {
                        let XL_row_object = utils.sheet_to_row_object_array(workbook.Sheets[sheetName]);

                        // rename file properties
                        let newXL_row_object = XL_row_object.map(item => {
                            return item;
                        })

                    }
                });
            };

            reader.readAsBinaryString(files[0]);

        }
        return;
    }

    const handlecompanyLogoOnChange = (e) => {
        const file = e.target.files[0];
        let ExtensionCheck = ExtensionChecker(file)
        let allowedExtension = ["jpeg", "jpg", "mpeg", "png"]
        if (!allowedExtension.includes(ExtensionCheck)) {
            toast.error('Incorret File Type')
            return
        }
        setLogoFile(file)
    }

    const updateUserUploadingStatus = (index, fieldName, status) => {


        setEmployeeList(prev => {

            let employeeListTemp = [...prev];

            employeeListTemp[index] = {
                ...employeeListTemp[index],
                [fieldName + "Status"]: status,
            };

            return employeeListTemp;
        });
    }

    const handleSubmit = async () => {
        // validations open
        setErrors({
            companyName: false,
            launchDate: false,
            companyId: false
        })
        let flag = 0
        if (!orgData.launchDate || !orgData.companyName) {
            toast.error('Check for required fields!')
            flag = 1
        }
        if (!orgData.launchDate) {
            setErrors(prev => ({ ...prev, launchDate: true }))
            flag = 1
        }
        if (!orgData.companyName) {
            setErrors(prev => ({ ...prev, companyName: true }))
            flag = 1
        }

        if (!employeeList) {
            toast.error('Empty Employee List!')
            flag = 1
        }
        else if (!logoFile) {
            toast.error('Empty Employee Logo!')
            flag = 1
        }

        if (flag === 1) {
            return false;
        }

        // validations close

        let tempOrgData = { ...orgData }
        tempOrgData.employeeList = employeeList
        tempOrgData.companyLogo = logoFile

        let formData = new FormData()
        formData.append('companyName', tempOrgData.companyName)
        formData.append('launchDate', tempOrgData.launchDate)
        formData.append('companyId', tempOrgData.companyId)
        formData.append('employeeList', JSON.stringify(tempOrgData.employeeList))
        formData.append('companyLogo', tempOrgData.companyLogo)

        const res = await apiCallV2("POST", "admin/add-organization", formData, localStorage.getItem("access-token"));
        if (res.data.status === 200) {

            let successCounter = 0, successIndicator = employeeList.length * 4;

            for (let x = 0; x < employeeList.length; x++) {

                updateUserUploadingStatus(x, "indi", 1);
                updateUserUploadingStatus(x, "recurly", 1);
                updateUserUploadingStatus(x, "sendgrid", 1);

                const signupRes = await apiCallV2("POST", "admin/add-company-user", {
                    user_name: employeeList[x].employee_first.toLowerCase().split(" ").join("").trim(" ") + "." + employeeList[x].employee_last.toLowerCase().split(" ").join("").trim(" "),
                    email_address: employeeList[x].employee_email.trim(" "),
                    user_type: 2, //1 is customer,0 is admin
                    password: "12345!Qa",
                    company: res.data.companyID,
                    employee_id: employeeList[x].employee_id,

                    first_name: employeeList[x].employee_first.trim(" "),
                    last_name: employeeList[x].employee_last.trim(" "),
                    work_location: employeeList[x].work_location,
                    department: employeeList[x].department,

                    mobile_number: employeeList[x].mobile_number ? (employeeList[x].mobile_number + "") : "",
                    company_name: tempOrgData.companyName,
                    launch_date: tempOrgData.launchDate,
                }, localStorage.getItem("access-token"));

                if (signupRes.status == 200 && signupRes.data.status == 200) {

                    const message = signupRes.data.message.toLowerCase();
                    successCounter += message.split("|").length;

                    updateUserUploadingStatus(x, "sendgrid", (message.includes("sendgrid")) ? 2 : 0);
                    updateUserUploadingStatus(x, "indi", (message.includes("indi")) ? 2 : 0);
                    updateUserUploadingStatus(x, "recurly", (message.includes("recurly")) ? 2 : 0);

                    updateUserUploadingStatus(x, "subscribe", 1);

                    const resPurchase = await apiCallV2(
                        "POST",
                        "create-subscription",
                        {
                            first_name: employeeList[x].employee_first,
                            last_name: employeeList[x].employee_last,
                            currency: "USD",
                            plan_id: "",
                            billing_zip: "",
                            coupon_code: [],
                            startDate: new Date(tempOrgData.launchDate),
                            renewal: false
                        },
                        signupRes.data.data.access_token
                    );

                    if (resPurchase.status == 200 && signupRes.data.status == 200) {

                        updateUserUploadingStatus(x, "subscribe", 2);
                        successCounter++;

                    } else {
                        updateUserUploadingStatus(x, "subscribe", 0);
                        toast.error('Ops! Sorry, Something went wrong!')
                        return false;
                    }

                } else if (signupRes.status === 409) {
                    updateUserUploadingStatus(x, "indi", 0);
                    updateUserUploadingStatus(x, "sendgrid", 0);
                    updateUserUploadingStatus(x, "recurly", 0);
                    updateUserUploadingStatus(x, "subscribe", 0);
                    updateUserUploadingStatus(x, "message", signupRes.data);
                } else {
                    toast.error(`Failed Adding - ${employeeList[x].employee_first.trim(" ") + " " + employeeList[x].employee_last.trim(" ")}`)
                    return false;
                }
            }


            if (successCounter === successIndicator) {

                // start: redirect after adding of employees all done
                toast.success('New Organization Added!')

                let toastId = toast.loading('Redirecting to super-user after 3 seconds ')
                setTimeout(() => {
                    navigate('/super-users')
                    toast.dismiss(toastId)
                }, 3000)
                // end

                // clearing of states after success storing of data
                setOrgData({
                    companyName: '',
                    launchDate: '',
                    companyId: '',
                    employeeList: '',
                    companyLogo: ''
                })
                setOrgFile('')
                setLogoFile('')
                setEmployeeList('')
                return true;
            } else {
                toast.success('New Organization Added!')
                toast.error('Failed to redirect, please check employee list status below');
                return false;
            }


        } else if (res.data.status === 500) {
            toast.error('Ops! Sorry, Something went wrong!')
            return false;
        } else {
            toast.error('Ops! Sorry, Something went wrong!')
            return false;
        }

    }

    const handlePaginate = (e, v) => {
        if (v === page) {
            return
        }
        setPage(v)
    }

    useEffect(() => {
        setCount(employeeList.length)
    }, [employeeList])

    let start = (perPage * page) - perPage;
    let end = start + perPage;
    let employeeListFiltered = [...employeeList];

    if (search && search.length > 2) {
        employeeListFiltered = employeeListFiltered.filter(em => em.employee_first.includes(search) || em.employee_last.includes(search) || em.employee_email.includes(search));
    }

    employeeListFiltered = employeeListFiltered.slice(start, end);

    const statusIcons = [
        <RiCloseLine className="custom-cross-icon" />,
        <RiLoader4Line className="custom-loader-icon rotate" />,
        <RiCheckLine className="custom-check-icon" />,
    ]

    return (
        <div className='add-organization-wrapper'>
            <div id="new-org-form">
                <h4>ORGANIZATION UPLOAD</h4>
                <div id="nof-header">
                    <div className='nof-info-group'>
                        <div className='nof-info-label'>
                            <h5>COMPANY NAME</h5>
                            <p>Use the form below to create new corporate accounts.</p>
                        </div>
                        <CustomInputV2 value={orgData?.companyName} name="companyName" onChange={handleInputOnChange} />

                    </div>
                </div>
                <div id="nof-other-info">
                    <div className='nof-info-group'>
                        <div className='nof-info-label'>
                            <h5>COMPANY LOGO</h5>
                            <p>Attach horizontal logo of organization.</p>
                        </div>
                        <p className='input-file-text'>{logoFile?.name}</p>
                        <CustomUploadButton onChange={handlecompanyLogoOnChange} />
                    </div>

                    <div className='nof-info-group'>
                        <div className='nof-info-label'>
                            <h5>EMPLOYEE LIST</h5>
                            <p>Attach the company directory below.</p>
                        </div>
                        <p className='input-file-text'>{orgFile?.name}</p>
                        <CustomUploadButton onChange={SetUploadedFile} />
                    </div>

                    <div className='nof-info-group'>
                        <div className='nof-info-label'>
                            <h5>LAUNCH DATE</h5>
                        </div>
                        <CustomRoundedInput type="date" value={orgData?.launchDate} name="launchDate" onChange={handleInputOnChange} error={errors.launchDate} helperText={errors.launchDate ? "Required Field" : ""} />
                    </div>

                    <div className='nof-action'>
                        <CustomActionButton action={handleSubmit}>SUBMIT</CustomActionButton>
                    </div>

                    <div>
                        {
                            employeeList.length > 0 &&
                            <CustomTable
                                title={"List of Employees (" + employeeList.length + ")"}
                                description=""
                                list={employeeList}
                                table={{
                                    headers: [
                                        { title: "#" },
                                        { title: "Employee ID", },
                                        { title: "Name", },
                                        { title: "Email", },
                                        { title: "Mobile Number", },
                                        { title: "Work Location", },
                                        { title: "Department", },
                                        { title: "INDI", },
                                        { title: "RECURLY", },
                                        { title: "SENDGRID", },
                                        { title: "SUBSCRIBED", },
                                        { title: "MESSAGE", },
                                    ],
                                    body: (emp, i) => {
                                        return (
                                            <tr className={i % 2 == 0 ? "tr-even" : ""}>
                                                <td><h6>{i + start}</h6></td>
                                                <td><h6>{emp.employee_id}</h6></td>
                                                <td><h6>{emp.employee_first.trim(" ") + " " + emp.employee_last.trim(" ")}</h6></td>
                                                <td><h6>{emp.employee_email}</h6></td>
                                                <td><h6>{emp.mobile_number}</h6></td>
                                                <td><h6>{emp.work_location}</h6></td>
                                                <td><h6>{emp.department}</h6></td>
                                                <td><h6>{statusIcons[emp?.indiStatus]}</h6></td>
                                                <td><h6>{statusIcons[emp?.recurlyStatus]}</h6></td>
                                                <td><h6>{statusIcons[emp?.sendgridStatus]}</h6></td>
                                                <td><h6>{statusIcons[emp?.subscribeStatus]}</h6></td>
                                                <td><h6 className='error-txt'>{emp?.messageStatus}</h6></td>
                                            </tr>
                                        )
                                    }
                                }}
                                pagination={{
                                    page: page,
                                    count: count,
                                    perPage: perPage,
                                    paginate: handlePaginate,
                                    setPerPage: (val) => {
                                        setPerPage(val);
                                    }
                                }}
                                actions={{
                                    search: {
                                        onChange: (e) => {
                                            setSearch(e.target.value);
                                        },
                                        onClick: () => { }
                                    }
                                }}
                            />
                        }

                    </div>

                </div>
            </div>
        </div>
    );
};

export default AddOrganization;